export default __webpack_public_path__ + "static/media/category-business.d38c52a4.jpg";